import type { ApprovalEntry } from './types';

function formatDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('de-DE', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

interface TimelineEvent {
  label: string;
  date: string;
  user: string | null;
  note?: string | null;
}

function buildEvents(approval: ApprovalEntry): TimelineEvent[] {
  const events: TimelineEvent[] = [
    {
      label: 'Eingereicht',
      date: approval.createdAt,
      user: approval.submitterDisplayName ?? approval.submitterId,
    },
  ];

  if (approval.reviewedAt) {
    const isApproved = approval.status === 'Approved' || approval.status === 'Live';
    events.push({
      label: isApproved ? 'Genehmigt' : 'Abgelehnt',
      date: approval.reviewedAt,
      user: approval.reviewerDisplayName ?? approval.reviewerId,
      note: approval.reviewNote,
    });
  }

  if (approval.liveAt) {
    events.push({
      label: 'Live geschaltet',
      date: approval.liveAt,
      user: null,
    });
  }

  return events;
}

export function ApprovalTimeline({ approval }: { approval: ApprovalEntry }) {
  const events = buildEvents(approval);

  return (
    <div className="relative ml-3 border-l border-muted-foreground/20 pl-4">
      {events.map((event, i) => (
        <div key={i} className="relative mb-3 last:mb-0">
          <div className="absolute -left-[calc(1rem+4.5px)] top-1.5 h-2 w-2 rounded-full bg-primary" />
          <p className="text-sm font-medium">{event.label}</p>
          <p className="text-xs text-muted-foreground">
            {formatDateTime(event.date)}
            {event.user && ` — ${event.user}`}
          </p>
          {event.note && (
            <p className="mt-0.5 text-xs italic text-muted-foreground">"{event.note}"</p>
          )}
        </div>
      ))}
    </div>
  );
}
